<template>
    <client-page>
        <div class="sub-visual sub-visual--sv5">
            <v-container>
                <h2 class="sub-visual__title"><span>ABOUT US</span></h2>
            </v-container>
        </div>

        <div class="tab-wrap mb-2 mb-lg-2">
            <v-container>
                <v-tabs :value="tab" grow show-arrows center-active class="tab tab--line">
                    <v-tab v-for="{ value, text } in tabs" :key="value" :to="`/en/aboutus/${value}`">
                        <span>{{ text }}</span>
                    </v-tab>
                </v-tabs>
            </v-container>
        </div>

        <v-tabs-items :value="tab" touchless>
            <!-- S: 회사소개 -->
            <about-us-company />
            <!-- E: 회사소개 -->
            <!-- S: 기사·뉴스 -->
            <about-us-news />
            <!-- E: 기사·뉴스 -->
            <!-- S: 위치 및 연락처 -->
            <about-us-location />
            <!-- E: 위치 및 연락처 -->
        </v-tabs-items>            
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import AboutUsCompany from "@/components/client/en/aboutus/about-us-company.vue";
import AboutUsNews from "@/components/client/en/aboutus/about-us-news.vue";
import AboutUsLocation from "@/components/client/en/aboutus/about-us-location.vue";
import { ABOUT_US_EN_TABS } from "@/assets/variables";
const tabs = Object.values(ABOUT_US_EN_TABS);

export default {
    components: {
        ClientPage,
        AboutUsCompany,
        AboutUsNews,
        AboutUsLocation,
    },
    props: {
        tab: { type: String, default: ABOUT_US_EN_TABS.COMPANY.value },
    },
    data() {
        return {
            tabs,
        };
    },
    mounted() {
        this.syncPath();
    },
    methods: {
        syncPath() {
            const path = `/en/aboutus/${this.tab}`;
            if (this.$route.path !== path) this.$router.replace(path);
        },
    },
};
</script>
